import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  H4, P, Row, Pagination
} from '@contently/toolkit';
import Story from './story';

export class AssignedStories extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1
    };
  }

  handlePageChange = (event) => {
    this.setState({ page: parseInt(event.target.dataset.page, 10) });
  }

  sortByTitle = (a, b) => {
    if (a.title === b.title) return 0;
    return a.title > b.title ? 1 : -1;
  };

  render() {
    const { stories, perPage } = this.props;
    const { page } = this.state;

    if (stories === null) return null;

    const numPages = Math.ceil(stories.length / perPage);
    const sortedStories = stories.sort(this.sortByTitle);

    const storiesForCurrentPage = () => {
      const start = ((page - 1) * perPage);
      const end = (page * perPage);
      return sortedStories.slice(start, end).map(story => <Story key={story.id} story={story} />);
    };

    return (
      <Row>
        <H4>In progress stories</H4>
        <div className="list-container">
          {stories.length > 0 ? (storiesForCurrentPage()) : <P>No stories found for the selected user.</P>}
        </div>
        { numPages > 1 && (
          <Pagination
            handlePageChange={this.handlePageChange}
            currentPage={page}
            numPages={numPages}
          />
        )}
      </Row>
    );
  }
}

AssignedStories.propTypes = {
  stories: PropTypes.arrayOf(PropTypes.object),
  perPage: PropTypes.number
};

AssignedStories.defaultProps = {
  stories: null,
  perPage: 15
};

const mapStateToProps = state => (
  {
    stories: state.reassignUsers.stories
  }
);

export default connect(mapStateToProps)(AssignedStories);



// WEBPACK FOOTER //
// ./app/javascript/app/components/reassign_users/assigned_stories.jsx